import type { Location } from 'react-router-dom'

/** Resolve a safe in-app path after login/register (blocks open redirects). */
export function resolvePostAuthPath(location: Location, searchParams: URLSearchParams): string {
  const fromState = location.state?.from?.pathname
  if (typeof fromState === 'string' && fromState.startsWith('/') && !fromState.startsWith('//')) {
    return fromState
  }

  const redirectParam = searchParams.get('redirect')
  if (redirectParam && redirectParam.startsWith('/') && !redirectParam.startsWith('//')) {
    return redirectParam
  }

  return '/app'
}
